<template>
    <q-table
        ref="table"
        :data="registrations"
        :columns="columns"
        row-key="id"
        :pagination.sync="pagination"
        @request="requestRegistrations"
        :loading="loading"
        :no-data-label="$t('no_data_avaliable')"
        :no-results-label="$t('no_results_found')"
        :loading-label="$t('loading_data')"
        :rows-per-page-label="$t('items_per_page')"
        :rows-per-page-options="[5,10,50,100]"
        binary-state-sort
        class="q-mt-lg"
        >

        <q-tr slot="header" slot-scope="props" :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ $t(col.label) }}
            </q-th>
        </q-tr>

        <template slot="body" slot-scope="props">
            <q-tr :props="props">
                <q-td key="id" :props="props">
                    {{ props.row.id }}
                </q-td>

                <q-td key="live_class_title" :props="props">
                    {{ props.row.live_class_title }}
                </q-td>

                <q-td key="subscribe_date" :props="props">
                    {{ fDate(props.row.subscribe_date) }}
                </q-td>

                <q-td key="live_class_date" :props="props">
                    {{ fDate(props.row.live_class_date) }}
                </q-td>

                <q-td key="is_mandatory" :props="props">
                    {{ $t(getMandatory(props.row.is_mandatory))}}
                </q-td>

                <q-td key="status" :props="props">
                    {{ $t(getStatus(props.row.status)) }}
                </q-td>
            </q-tr>
        </template>
    </q-table>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date

export default {
    data() {
        return {
            pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                descending: false,
                sortBy: null
            },
            columns: [
                {
                    name: 'id',
                    required: true,
                    label: '#',
                    align: 'left',
                    field: 'id',
                    sortable: true,
                },
                {
                    name: 'live_class_title',
                    required: true,
                    label: 'title',
                    align: 'left',
                    field: 'live_class_title',
                    sortable: true,
                },
                {
                    name: 'subscribe_date',
                    required: true,
                    label: 'enrollment_date',
                    align: 'left',
                    field: 'subscribe_date',
                    sortable: true,
                },
                {
                    name: 'live_class_date',
                    required: true,
                    label: 'training_date',
                    align: 'left',
                    field: 'live_class_date',
                    sortable: true,
                },
                {
                    name: 'is_mandatory',
                    required: true,
                    label: 'type',
                    align: 'left',
                    field: 'is_mandatory',
                    sortable: false,
                },
                {
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'left',
                    field: 'status',
                    sortable: false,
                }
            ],
            registrations: [],
            loading: false
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            id_user_language_selected: 'common/id_user_language_selected',
            selected_user: 'users/selected_user',
            num_rows: 'datatable/num_rows'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },
    },

    methods: {
        requestRegistrations({ pagination }) {
            this.loading = true
            this.pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.pagination.rowsPerPage,
                "page": this.pagination.page,
                "ordering": order_by
            }

            this.savePagination()

            this.$axios.get(`/admin_users/users/${this.selected_user}/get_user_live_classes_subscription/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.pagination.rowsNumber = response.data.count

                this.registrations = response.data.results.map(e => {
                    return { ...e }
                })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.loading = false
            })
        },

        fDate(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY HH:mm:ss'
                    break
                    default: format = 'MM-DD-YYYY HH:mm:ss'
                    break
                }

                return date.formatDate(d, format)
            }
        },

        getMandatory(isMandatory) {
            if (isMandatory == null || isMandatory == false) {
                return 'optional'
            } else {
                return 'mandatory'
            }
        },

        getStatus(status) {
            if(status == 1) return 'aproved'
            if(status == 2) return 'reproved'
            if(status == 3) return 'missed'
            if(status == 4)  return 'in_progress'
            if(status == null) return 'pending'
        },

        savePagination() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.pagination.rowsPerPage])
        },

        loadPagination() {
            this.pagination.rowsPerPage = this.num_rows
        }
    },

    watch: {
        num_rows: {
            handler (newValue) {
                this.loadPagination()
            },
            deep: true
        }
    },

    created() {
        this.loadPagination()

        this.requestRegistrations({ pagination: this.pagination })
    }
}
</script>

<style>

</style>
